import * as React from 'react';

import {ActionBox} from 'shells/action-box/action-box';
import {TextButtonWithConfirmation} from 'shells/button/text-button-with-confirmation/text-button-with-confirmation';
import {GoogleCalendarIcon} from 'shells/icon/svg/google-calendar-icon';
import {OutlookCalendarIcon} from 'shells/icon/svg/outlook-calendar-icon';

import type {GetCalendars_calendars as Calendar} from 'nutshell-graphql-types';

import {CalendarTitleWithSyncError} from './calendar-title-with-sync-error';

type Props = {
    calendar: Calendar;
    onConfirmDisconnect: (calendarId: string) => Promise<any>;
};

export function ConflictCalendarWidget(props: Props) {
    const [isRemovingConflictCalendar, setIsRemovingConflictCalendar] = React.useState(false);

    return (
        <ActionBox
            actionElement={
                <TextButtonWithConfirmation
                    buttonVariant='text-danger'
                    // @ts-expect-error
                    size='xlarge'
                    onConfirm={() => {
                        setIsRemovingConflictCalendar(true);
                        props
                            .onConfirmDisconnect(props.calendar.id)
                            .then(() => setIsRemovingConflictCalendar(false));
                    }}
                    buttonText={isRemovingConflictCalendar ? 'Disconnecting…' : 'Disconnect'}
                    question='Are you sure you want to disconnect this calendar?'
                    primaryText={isRemovingConflictCalendar ? 'Disconnecting…' : 'Disconnect'}
                    secondaryText='Cancel'
                    buttonSize='xlarge'
                />
            }
            title={
                props.calendar.syncErrors.length > 0 ? (
                    <CalendarTitleWithSyncError
                        title={props.calendar.name}
                        errorMessage='Cannot sync with this calendar'
                        tooltipText='This calendar cannot be connected.<br />Disconnect and try again.'
                    />
                ) : (
                    props.calendar.name
                )
            }
            subtitle={props.calendar.username}
            icon={
                props.calendar.serviceType === 'OFFICE365' ? (
                    <OutlookCalendarIcon size={24} />
                ) : (
                    <GoogleCalendarIcon size={24} />
                )
            }
        />
    );
}
